import { Children, cloneElement, isValidElement, ReactNode } from 'react';
import Accordion, { AccordionProps } from '../Accordion';
import useAccordionGroup, { UseAccordionGroup } from './vm';
import { Stack } from '@mui/material';
import { AccordionGroupContextProvider } from './Context';

export interface AccordionGroupProps extends UseAccordionGroup {
  children: ReactNode;
  className?: string;
}

const AccordionGroup = ({ children, className, ...vmProps }: AccordionGroupProps) => {
  const { getIsOpen, toggleOpen } = useAccordionGroup(vmProps);
  return (
    <AccordionGroupContextProvider>
      <Stack gap={2} className={className}>
        {Children.map(children, (child) => {
          if (isValidElement(child) && child.type === Accordion) {
            const overriddenProps: AccordionProps = {
              ...child.props,
              isOpen: getIsOpen(child.props.identifier),
              onClick: toggleOpen(child.props.identifier, child.props.onClick),
            };
            return cloneElement(child, overriddenProps);
          }
          return child;
        })}
      </Stack>
    </AccordionGroupContextProvider>
  );
};

export default AccordionGroup;
